import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import GoogleSearchModal from './GoogleSearchModal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ahobilam.com';
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : `${BACKEND_URL}/api`;

const SearchEngine = ({ language = 'en' }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [isGoogleModalOpen, setIsGoogleModalOpen] = useState(false);
  
  const [reqData, setReqData] = useState({ requirement: '', expected_time: '', user_name: '', user_email: '' });
  const [reqStatus, setReqStatus] = useState('');
  
  const searchRef = useRef(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    
    setIsSearching(true);
    setHasSearched(true);
    setShowRequestForm(false);
    
    const qLower = query.trim().toLowerCase();
    const isTheetu = ["theetu", "thittu", "thiitu", "teetu", "dheetu", "dhitu", "theetoo", "theettu", "asoucham", "asaucam", "தீட்டு", "ஆசௌச", "ஜனன", "மரண"].some(k => qLower.includes(k));

    try {
      const response = await axios.post(`${API}/search`, {
        term: query,
        user_name: 'Guest'
      });
      let resList = response.data.results || [];
      
      if (isTheetu && !resList.some(r => r.slug === 'vaideekam/asoucham')) {
        resList.unshift({
          category: 'sastram',
          type: 'sastram',
          slug: 'vaideekam/asoucham',
          url: '/vaideekam/asoucham',
          title: 'Asoucham - ஜனன மரண தீட்டு விபரம் & கணிப்பான் (Theetu Calculator)',
          snippet: 'ஜனன மரண தீட்டு கணக்கீடு, 10 நாள் பங்காளிகள், பக்ஷிணீ 1.5 நாள், கர்ப்பச்சிதைவு மற்றும் ஆசௌச தர்ம சாஸ்திர விதிகள்.'
        });
      }
      setResults(resList);
    } catch (error) {
      console.error('Search failed', error);
      if (isTheetu) {
        setResults([{
          category: 'sastram',
          type: 'sastram',
          slug: 'vaideekam/asoucham',
          url: '/vaideekam/asoucham',
          title: 'Asoucham - ஜனன மரண தீட்டு விபரம் & கணிப்பான் (Theetu Calculator)',
          snippet: 'ஜனன மரண தீட்டு கணக்கீடு, 10 நாள் பங்காளிகள், பக்ஷிணீ 1.5 நாள், கர்ப்பச்சிதைவு மற்றும் ஆசௌச தர்ம சாஸ்திர விதிகள்.'
        }]);
      } else {
        setResults([]);
      }
    } finally {
      setIsSearching(false);
    }
  };

  const openInSiteGoogleModal = () => {
    setIsGoogleModalOpen(true);
    setHasSearched(false);
  };

  const submitContentRequest = async (e) => {
    e.preventDefault();
    setReqStatus('sending');
    try {
      await axios.post(`${API}/content-request`, {
        ...reqData,
        requirement: reqData.requirement || query,
        user_name: reqData.user_name || 'Guest',
        user_email: reqData.user_email || ''
      });
      setReqStatus('success');
      setReqData({ requirement: '', expected_time: '', user_name: '', user_email: '' });
    } catch (err) {
      setReqStatus('error');
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setHasSearched(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="search-engine-wrapper" ref={searchRef} style={{ width: '100%', maxWidth: 'clamp(170px, 22vw, 250px)', minWidth: '140px', flexShrink: 1, display: 'inline-block', position: 'relative', zIndex: 50 }}>
      <form onSubmit={handleSearch} style={{ display: 'flex', position: 'relative', height: '42px' }}>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={language === 'en' ? "🔍 Search rituals, panchangam..." : "🔍 தேடுக..."}
          style={{
            width: '100%',
            height: '100%',
            padding: '0.6rem 2.8rem 0.6rem 1.2rem',
            fontSize: '0.92rem',
            fontWeight: '600',
            borderRadius: '0.75rem',
            border: '2px solid #D4AF37',
            background: '#FFFFFF',
            color: '#1A237E',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            outline: 'none',
            transition: 'all 0.3s ease'
          }}
          className="search-input"
        />
        <div style={{ display: 'flex', gap: '6px', position: 'absolute', right: '4px', top: '4px', bottom: '4px' }}>
          <button 
            type="submit" 
            disabled={isSearching}
            title="Local Site Search"
            style={{
              padding: '0 12px',
              borderRadius: '0.5rem',
              border: 'none',
              background: '#1A237E',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold'
            }}
          >
            {isSearching ? <span style={{width: '16px', height: '16px', border: '2px solid #fff', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 1s linear infinite'}}></span> : '🔍'}
          </button>

          <button 
            type="button" 
            onClick={openInSiteGoogleModal}
            title="Google Programmable Search Engine"
            style={{
              padding: '0 12px',
              borderRadius: '0.5rem',
              border: 'none',
              background: '#CC6600',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '0.82rem',
              gap: '4px'
            }}
          >
            <span>🌐</span>
            <span>Google</span>
          </button>
        </div>
      </form>

      {hasSearched && !isSearching && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          marginTop: '10px',
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
          overflow: 'hidden',
          textAlign: 'left'
        }}>
          {/* Direct In-Site Google Search Button Header */}
          <div style={{ padding: '8px 12px', background: '#FAF6EE', borderBottom: '1px solid #E0E0E0' }}>
            <button
              onClick={openInSiteGoogleModal}
              style={{
                width: '100%',
                padding: '8px 12px',
                background: 'linear-gradient(135deg, #1A73E8, #1557B0)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '0.85rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                boxShadow: '0 2px 6px rgba(26,115,232,0.3)'
              }}
            >
              <span>🌐</span>
              <span>Search inside website with Google</span>
            </button>
          </div>

          {results.length > 0 ? (
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {results.map((item, idx) => (
                <Link 
                  key={idx} 
                  to={item.url || (item.type === 'blog' ? `/blog/${item.slug}` : `/${item.slug}`)}
                  style={{ display: 'block', padding: '12px 20px', color: '#1A237E', textDecoration: 'none', borderBottom: '1px solid #eee', fontSize: '0.95rem', fontWeight: '600' }}
                  onClick={() => setHasSearched(false)}
                >
                  <span style={{ fontSize: '0.75rem', color: '#CC6600', marginRight: '8px', textTransform: 'uppercase', background: '#F5EDDA', padding: '2px 6px', borderRadius: '4px' }}>{item.category || item.type}</span>
                  {item.title}
                </Link>
              ))}
            </div>
          ) : (
            <div style={{ padding: '20px' }}>
              <div style={{ padding: '15px', background: '#fff3cd', color: '#856404', borderRadius: '8px', marginBottom: '15px', fontSize: '0.95rem', border: '1px solid #ffeeba' }}>
                <strong>No local matches found for "{query}".</strong> <br/>
                Click the blue Google Search button above to search Google's index directly inside this site!
              </div>
              
              {!showRequestForm ? (
                <button onClick={() => { setShowRequestForm(true); setReqData({...reqData, requirement: query}); }} style={{ width: '100%', padding: '10px', background: '#1A237E', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
                  📝 Request Content from Admin
                </button>
              ) : (
                <form onSubmit={submitContentRequest}>
                  <div style={{ marginBottom: '10px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem', color: '#555' }}>Your Name (Optional)</label>
                    <input type="text" value={reqData.user_name} onChange={e => setReqData({...reqData, user_name: e.target.value})} placeholder="Name" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem', color: '#555' }}>Your Email (Optional, to get reply)</label>
                    <input type="email" value={reqData.user_email} onChange={e => setReqData({...reqData, user_email: e.target.value})} placeholder="Email" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
                  </div>
                  <div style={{ marginBottom: '10px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem', color: '#555' }}>Your Requirement</label>
                    <textarea required value={reqData.requirement} onChange={e => setReqData({...reqData, requirement: e.target.value})} placeholder="E.g. Detailed procedure for Vasthu Shanthi" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minHeight: '60px' }} />
                  </div>
                  <div style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '0.9rem', color: '#555' }}>Expected Time (Urgency)</label>
                    <input required type="text" value={reqData.expected_time} onChange={e => setReqData({...reqData, expected_time: e.target.value})} placeholder="E.g. By this weekend" style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }} />
                  </div>
                  {reqStatus === 'success' ? <div style={{ color: 'green', fontWeight: 'bold', textAlign: 'center' }}>Request sent successfully!</div> : reqStatus === 'error' ? <div style={{ color: 'red', textAlign: 'center', marginBottom: '10px' }}>Failed to send. Try again.</div> : null}
                  {reqStatus !== 'success' && (
                    <button type="submit" disabled={reqStatus === 'sending'} style={{ width: '100%', padding: '10px', background: '#28a745', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>
                      {reqStatus === 'sending' ? 'Sending...' : 'Submit Request'}
                    </button>
                  )}
                </form>
              )}
            </div>
          )}
        </div>
      )}

      {/* In-Site Google CSE Search Modal */}
      <GoogleSearchModal
        isOpen={isGoogleModalOpen}
        onClose={() => setIsGoogleModalOpen(false)}
        initialQuery={query}
      />

      <style>{`.search-input::placeholder { color: rgba(26,35,126,0.6); } .search-input:focus { background: #FFFFFF; border-color: #CC6600; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default SearchEngine;
